import { TextField } from "@mui/material";
import { TextFieldProps } from "../../interfaces/props/TextfieldProps";
import './styles.css'
import { useAccessibility } from "../../Store/contexts/AccessibilityContext";
import { useId } from "react";

function DefaultTextField(props: TextFieldProps) {

    const accessibility = useAccessibility();
    const id = useId();

    return (
        <div className="unimed-textfield">
            {props.labeled && (
                <>
                  <span className="unimed-textfield-label">{props.label}</span>
                  <label htmlFor={id} aria-label={props.label} />
                </>)
            }
            <TextField
                id={id}
                variant="outlined"
                onChange={props.handleChange}
                value={props.value}
                sx={{
                  width: '100%',
                  input: {
                    fontFamily: 'Unimed-Sans',
                    color: '#383838',
                    fontSize: '16px',
                  },
                  '@media (max-width: 1130px)': {
                    width: '100%'
                  },
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: accessibility.contrastMode ? 'black' : '',
                    '& fieldset': {
                      borderColor: accessibility.contrastMode ? 'white' : '',
                    },
                  },
                }}
                inputProps={{ style: { color: accessibility.contrastMode ? 'white' : '' } }}
                fullWidth
                disabled={false} 
                placeholder={props.placeholder || ''}
              />
        </div>
    );
}

export default DefaultTextField;